import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ProblemForUserModel } from './model';

export const problemForUserAdapter: EntityAdapter<ProblemForUserModel> = createEntityAdapter<ProblemForUserModel>({
  selectId: model => model.id,
});

export interface ProblemForUserState extends EntityState<ProblemForUserModel> {
  isLoading?: boolean;
  error?: any;
}

export const initialState: ProblemForUserState = problemForUserAdapter.getInitialState({
  isLoading: false,
  error: null,
});
